import { apiClient } from './apiClient';
import type { UnbilledTransactionsResponse, IssueConsolidatedInvoicesResponse } from '../types/invoicing';

export const invoicingService = {
  async getUnbilledTransactions(
    businessProfileId: string,
    year: number,
    month: number,
    authToken: string
  ): Promise<UnbilledTransactionsResponse> {
    return apiClient.get<UnbilledTransactionsResponse>(
      `/business-profile/${businessProfileId}/invoicing/unbilled-transactions?year=${year}&month=${month}`,
      authToken
    );
  },

  async issueConsolidatedInvoices(
    businessProfileId: string,
    paymentIds: string[],
    authToken: string
  ): Promise<IssueConsolidatedInvoicesResponse> {
    return apiClient.post<IssueConsolidatedInvoicesResponse>(
      `/business-profile/${businessProfileId}/invoicing/issue`,
      { paymentIds },
      authToken
    );
  },

  async setConsolidatedInvoicingEnabled(
    businessProfileId: string,
    enabled: boolean,
    authToken: string
  ): Promise<void> {
    await apiClient.put(
      `/business-profile/${businessProfileId}/invoicing/consolidated-status`,
      { enabled },
      authToken
    );
  },
};
